import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { DEAL_HISTORY_INFO, DEAL_STAGE } from '../../constants/DealHistoryConstants';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const StageCell = styled.div.withConfig({
  displayName: "DealStageHistory__StageCell",
  componentId: "sc-1gzpsu8-0"
})(["padding-top:8px;"]);
export const DealStageHistory = ({
  stageProgress,
  showText
}) => {
  var _DEAL_HISTORY_INFO$DE2;
  const renderStatus = () => {
    var _DEAL_HISTORY_INFO$DE;
    if (showText) {
      var _DEAL_HISTORY_INFO$de;
      return /*#__PURE__*/_jsx(StatusTag, {
        "data-test-id": "deal-stage-history-tag",
        children: I18n.text(((_DEAL_HISTORY_INFO$de = DEAL_HISTORY_INFO.dealStage) === null || _DEAL_HISTORY_INFO$de === void 0 || (_DEAL_HISTORY_INFO$de = _DEAL_HISTORY_INFO$de[stageProgress]) === null || _DEAL_HISTORY_INFO$de === void 0 ? void 0 : _DEAL_HISTORY_INFO$de.i18nKey) || '')
      });
    }
    return /*#__PURE__*/_jsx(StatusDot, {
      "data-test-id": "deal-stage-history-dot",
      marginInlineStart: "100",
      use: (_DEAL_HISTORY_INFO$DE = DEAL_HISTORY_INFO[DEAL_STAGE]) === null || _DEAL_HISTORY_INFO$DE === void 0 ? void 0 : _DEAL_HISTORY_INFO$DE[stageProgress].useKeyWord
    });
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: ((_DEAL_HISTORY_INFO$DE2 = DEAL_HISTORY_INFO[DEAL_STAGE]) === null || _DEAL_HISTORY_INFO$DE2 === void 0 || (_DEAL_HISTORY_INFO$DE2 = _DEAL_HISTORY_INFO$DE2[stageProgress]) === null || _DEAL_HISTORY_INFO$DE2 === void 0 ? void 0 : _DEAL_HISTORY_INFO$DE2.tooltipText) || ''
    }),
    children: renderStatus()
  });
};